import React from "react";
import {Button} from "antd";
import {useTranslation} from "react-i18next";
import useShared from "../../../../../_common/_shared";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {globalColorThemeState, globalLanguageListState} from "../../../../../_common/global_state";
import {useIsMobile} from "../../../../../_common/function";
import {useNavigate} from "react-router-dom";
import useLayoutFunction from "../../../../function";
import {useVerification} from "../../../../../_common/_authorize";

const NestedPopoverContent = ({
                                  platformDownloadKey,
                                  platformData,
                                  popoverContentConfigKey,
                                  setPopoverContentConfigKey,
                                  setPopoverOpen,
                                  setOpenQrModal
                              }) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const isMobile = useIsMobile(768);
    const {IconFlag} = useShared();
    const {changeLanguageHandler} = useLayoutFunction();
    const {handleTokenExpiration} = useVerification();

    const languageListState = useRecoilValue(globalLanguageListState);
    const setColorState = useSetRecoilState(globalColorThemeState);

    if (platformDownloadKey.some((k) => k[0] === popoverContentConfigKey)) {
        const platforms = Object.entries(platformData[popoverContentConfigKey]).reduce(
            (a, b) => (b?.[1]?.__typename === "LinkObject" && b?.[1]?.isEnabled && b?.[1]?.link ? [...a, b] : a),
            []
        );
        return platforms.map((p, i) => (
            <Button
                key={i}
                type={"text"}
                onClick={() => window.open(p?.[1]?.link, "_blank")}
            >
                {p?.[1]?.displayName}
            </Button>
        ))
    }

    switch (popoverContentConfigKey) {
        case "language":
            return (languageListState ?? [])?.map((lang) => (
                <Button
                    key={lang?.nativeName}
                    type={"text"}
                    onClick={() => changeLanguageHandler(lang?.code)}
                >
                    <IconFlag countryCode={lang?.countryCode} style={{width: "24px", marginRight: "8px"}}/>
                    <div>{lang?.nativeName}</div>
                </Button>
            ))
        case "theme":
            return (
                <>
                    <Button
                        type={"text"}
                        onClick={() => {
                            setColorState("light");
                            localStorage.setItem("color", "light");
                        }}
                    >
                        {t("common.light")}
                    </Button>
                    <Button
                        type={"text"}
                        onClick={() => {
                            setColorState("dark");
                            localStorage.setItem("color", "dark");
                        }}
                    >
                        {t("common.dark")}
                    </Button>
                </>
            );

        case "download":
            return platformDownloadKey.map(([k], i) => (
                <Button
                    key={i}
                    type={"text"}
                    onClick={() => setPopoverContentConfigKey(k)}
                >
                    {k}
                </Button>
            ))

        default:
            return (
                <>
                    <Button
                        type={"text"}
                        onClick={() => setPopoverContentConfigKey("language")}
                    >
                        {t("common.language")}
                    </Button>
                    <Button
                        type={"text"}
                        onClick={() => setPopoverContentConfigKey("theme")}
                    >
                        {t("common.theme")}
                    </Button>
                    <Button
                        type={"text"}
                        onClick={() => navigate("/profile")}
                    >
                        {t("common.bookmark")}
                    </Button>
                    {platformDownloadKey?.length ? (
                        <Button
                            type={"text"}
                            onClick={() => setPopoverContentConfigKey("download")}
                        >
                            {t("common.download")}
                        </Button>
                    ) : null}
                    {isMobile && (
                        <>
                            <Button
                                type={"text"}
                                onClick={() => {
                                    setOpenQrModal(true);
                                    setPopoverOpen(false);
                                }}
                            >
                                {t("referral.modal.title")}
                            </Button>
                            <Button
                                type={"text"}
                                onClick={() => navigate("/profile")}
                            >
                                {t("common.editProfile")}
                            </Button>
                            <Button
                                type={"text"}
                                onClick={handleTokenExpiration}
                            >
                                {t("common.logOut")}
                            </Button>
                        </>
                    )}
                </>
            );
    }
};

export default NestedPopoverContent
